import React from "react";

export default function Telegram() {
  return (


      <svg width="36" height="38" viewBox="0 0 36 38" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_14313_119169)">
              <path d="M35.9996 18.8656C35.9996 8.58425 27.9401 0.25 17.9996 0.25C8.05462 0.252313 -0.00488281 8.58425 -0.00488281 18.8679C-0.00488281 28.1573 6.57862 35.8579 15.1826 37.2546V24.2468H10.6151V18.8679H15.1871V14.7633C15.1871 10.0989 17.8759 7.52281 21.9866 7.52281C23.9576 7.52281 26.0164 7.88588 26.0164 7.88588V12.4646H23.7461C21.5119 12.4646 20.8144 13.9007 20.8144 15.3737V18.8656H25.8049L25.0084 24.2445H20.8121V37.2523C29.4161 35.8556 35.9996 28.1549 35.9996 18.8656Z" fill="#425893"/>
          </g>
          <defs>
              <clipPath id="clip0_14313_119169">
                  <rect width="36" height="37" fill="white" transform="translate(0 0.251953)"/>
              </clipPath>
          </defs>
      </svg>


  );
}
